import Loadable, { NullLoader } from '@comeon/loadable';

const SportsbookLivePageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-live-page" */
			'./sportsbook-live-page-container'
		),
	loading: NullLoader
});

const SportsbookLiveSportsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-live-page" */
			'./live-sports/sportsbook-live-sports-container'
		),
	loading: NullLoader
});

export { SportsbookLivePageContainer, SportsbookLiveSportsContainer };
